import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.slice.js";
import { defineIntegration } from '../integration.js';
import { stripMetadataFromStackFrames, addMetadataToStackFrames } from '../metadata.js';
import { forEachEnvelopeItem } from '../utils-hoist/envelope.js';
import { getFramesFromEvent } from '../utils-hoist/stacktrace.js';

/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */
var thirdPartyErrorFilterIntegration = defineIntegration(function (options) {
  return {
    name: 'ThirdPartyErrorsFilter',
    setup: function setup(client) {
      // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
      // TODO(lforst): Move this cleanup logic into a more central place in the SDK.
      client.on('beforeEnvelope', function (envelope) {
        forEachEnvelopeItem(envelope, function (item, type) {
          if (type === 'event') {
            var event = Array.isArray(item) ? item[1] : undefined;
            if (event) {
              stripMetadataFromStackFrames(event);
              item[1] = event;
            }
          }
        });
      });
      client.on('applyFrameMetadata', function (event) {
        // Only apply stack frame metadata to error events
        if (event.type) {
          return;
        }
        var stackParser = client.getOptions().stackParser;
        addMetadataToStackFrames(stackParser, event);
      });
    },
    processEvent: function processEvent(event) {
      var frameKeys = getBundleKeysForAllFramesWithFilenames(event);
      if (frameKeys) {
        var arrayMethod = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'apply-tag-if-contains-third-party-frames' ? 'some' : 'every';
        var behaviourApplies = frameKeys[arrayMethod](function (keys) {
          return !keys.some(function (key) {
            return options.filterKeys.includes(key);
          });
        });
        if (behaviourApplies) {
          var shouldDrop = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'drop-error-if-exclusively-contains-third-party-frames';
          if (shouldDrop) {
            return null;
          } else {
            event.tags = _objectSpread(_objectSpread({}, event.tags), {}, {
              third_party_code: true
            });
          }
        }
      }
      return event;
    }
  };
});
function getBundleKeysForAllFramesWithFilenames(event) {
  var frames = getFramesFromEvent(event);
  if (!frames) {
    return undefined;
  }
  return frames
  // Exclude frames without a filename since these are likely native code or built-ins
  .filter(function (frame) {
    return !!frame.filename;
  }).map(function (frame) {
    if (frame.module_metadata) {
      return Object.keys(frame.module_metadata).filter(function (key) {
        return key.startsWith(BUNDLER_PLUGIN_APP_KEY_PREFIX);
      }).map(function (key) {
        return key.slice(BUNDLER_PLUGIN_APP_KEY_PREFIX.length);
      });
    }
    return [];
  });
}
var BUNDLER_PLUGIN_APP_KEY_PREFIX = '_sentryBundlerPluginAppKey:';
export { thirdPartyErrorFilterIntegration };